module.exports = __webpack_public_path__ + "img/piece.5410128e.png";